import { render, staticRenderFns } from "./sourceContent.vue?vue&type=template&id=1b315672&scoped=true"
import script from "./sourceContent.vue?vue&type=script&lang=js"
export * from "./sourceContent.vue?vue&type=script&lang=js"
import style0 from "./sourceContent.vue?vue&type=style&index=0&id=1b315672&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b315672",
  null
  
)

export default component.exports